/// <reference types="@types/office-js" />

import { SingleLanguageResources } from "../shared/resources";
import { localizeResources } from "../shared/resources";
import { Injectable } from "@angular/core";
import { OutlookService } from "./outlook/outlook.service";

@Injectable()
export class ResourceService {
  private readonly resourceLanguages: string[] = [
    "CS",
    "DA",
    "DE",
    "EN",
    "ES",
    "FI",
    "FR",
    "IT",
    "NL",
    "NO",
    "PL",
    "SV",
    "BR",
    "VI",
    "KO",
    "ZH"
  ];
  private readonly defaultLanguage: string = "EN";
  private readonly currentLanguage: string;
  private localizeSingleLanguageResources: SingleLanguageResources;

  constructor(private readonly outlookService: OutlookService) {
    this.currentLanguage = (
      this.outlookService.displayLanguage.split("-")[0] || this.defaultLanguage
    ).toUpperCase();

    // brazilian portuguese is reported as PT-BR
    if (this.currentLanguage === "PT") {
      this.currentLanguage = "BR";
    }

    if (this.currentLanguage === "NB") {
      this.currentLanguage = "NO";
    }

    if (this.resourceLanguages.indexOf(this.currentLanguage) === -1) {
      this.currentLanguage = this.defaultLanguage;
    }
  }

  loadLocalizeResources(): Promise<SingleLanguageResources> {
    return new Promise<SingleLanguageResources>((resolve, reject) => {
      try {
        const singleLanguageResources = localizeResources(this.currentLanguage);
        this.localizeSingleLanguageResources = singleLanguageResources
        resolve(singleLanguageResources);
      } catch (e) {
        reject(e);
      }
    });
  }

  get localizeResources(): SingleLanguageResources {
    return this.localizeSingleLanguageResources;
  }

  /**
   * This returns the current accepted language of the user
   */
  public currentUILanguage(): string {
    return this.currentLanguage;
  }
}
